import React, { useState } from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import TreatmentText from '../../TreatmentText'
import TreatmentOutcome from '../../TreatmentOutcome'
import TreatmentSubmitModule from '../../TreatmentSubmitButton'
import BleedType from './BleedType'
import AffectedArea from './AffectedArea'
import ControlMethods from './ControlMethods'
import HaemAgent from './HaemAgent'
import Tourniquet from './Tourniquet'
import BleedControlled from './BleedControlled'

const CatHaem = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Catastrophic Haemorrhage</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <BleedType
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <AffectedArea
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <ControlMethods
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <HaemAgent
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Tourniquet
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <BleedControlled
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentOutcome
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          lg={8}
        />
        <TreatmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <TreatmentSubmitModule
          submitModule={submitModule}
          moduleValues={moduleValues}
          moduleName="Catastrophic Haemorrhage"
        />
      </Grid>
    </Box>
  )
}

export default CatHaem
